import {ButtonTheme} from 'common/components/button/constants';
import {SharableEntityGrant, SharableEntityType} from 'common/report/util/saved-entities/types';

export const enum SharingMenuLabels {
  CopyLink = `Copy Link`,
  ManageSharing = `Manage Sharing`,
}

export interface SharingStatusButtonState {
  data: SharableEntityGrant;
  error: Error;
}

export interface SharingStatusButtonAttrs {
  disabled: boolean;
  id: number;
  'project-id': number;
  'is-select': boolean;
  'tooltip-text': string;
  theme: ButtonTheme;
  type: SharableEntityType;
}
